/**
 * An empty upload never starts a read. Zero bytes and whitespace text
 * are decided here, before any request. A Word file of only spaces is
 * still found by the cost preview; Proceed stays off either way.
 */

import { UPLOAD_FILE_EMPTY } from '../../utils/writerCopy';

export { UPLOAD_FILE_EMPTY };

const TEXT_EXT = /\.(txt|md|markdown|text)$/i;

export function textIsEmpty(text) {
  return !String(text ?? '').trim();
}

function readAsText(file) {
  if (file && typeof file.text === 'function') return file.text();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(reader.error || new Error('Could not read the file'));
    reader.readAsText(file);
  });
}

export async function fileIsEmpty(file) {
  if (!file || file.size === 0) return true;
  const name = String(file.name || '');
  const type = String(file.type || '');
  const textLike = TEXT_EXT.test(name) || type.startsWith('text/');
  if (!textLike) return false;
  try {
    const text = await readAsText(file);
    return textIsEmpty(text);
  } catch {
    return false;
  }
}

export function emptyBatchPreview(batch) {
  const files = (batch || []).map((entry) => ({
    original_filename: entry?.file?.name || 'untitled',
    declared_format: entry?.declaredFormat || '',
    word_count: 0,
    readable: false,
    reason: UPLOAD_FILE_EMPTY,
  }));
  return {
    word_count: 0,
    approximate_cost_usd: 0,
    can_estimate: true,
    files,
  };
}
